import communicationmoduleservice from '../services/communicationmoduleservice';
import * as appActions from '../../../actions/appactions';
import * as types from "./actiontype";
import { checkAccess } from '../../../actions/securityactions'
import * as appConstants from '../../../overrides/appconstants';
import * as appUtilityFunctions from '../../../infrastructure/apputilityfunctions'
import communicationModuleService from '../services/communicationmoduleservice';


export const setCommunicationModuleMasters = (result) => {
    return {
        type: types.SET_COMMUNICATION_MODULE_MASTERS,
        result
    }
}

export const setModalState = ({ name, value }) => {
    return {
        type: types.SET_MODAL_STATE,
        payload: { name, value }
    }
}

export const setCreateLinkParams = ({ name, value }) => {
    return {
        type: types.SET_CREATE_LINK_PARAMS,
        payload: { name, value }
    }
}

export const updateModalsStateParams = ({ name, value }) => {
    return {
        type: types.UPDATE_MODAL_DISPLAY_STATE_REPORT_ENGINE,
        payload: { name, value }
    }
}
export const onChangeCommunicationModuleSearchParams = ({ name, value }) => {
    return {
        type: types.UPDATE_COMMUNICATION_MODULE_PARAMS,
        payload: { name, value }
    }
}
export const onResetCommunicationModuleSearchParams = () => {
    return {
        type: types.RESET_COMMUNICATION_MODULE_PARAMS,
    }
}
export const onResetCommunicationModuleSearchParamsExceptSearch = () => {
    return {
        type: types.RESET_COMMUNICATION_MODULE_PARAMS_EXCEPT_SEARCH,
    }
}

export const resetCommunicationTaskAssignment = () => {
    return {
        type: types.RESET_COMMUNICATION_TASK_ASSIGNMENT
    }
}

export const setCommunicationTaskAssignEntryParams = ({ name, value }) => {
    return {
        type: types.SET_COMMUNICATION_TASK_ASSIGN_ENTRY_PARAMS,
        payload: { name, value }
    }
}


export function searchCommunicationMaster(page) {
    return async function (dispatch, state) {
        try {
            let currentState = getState(state());
            dispatch(appActions.setLoading(true));
            var inputPara = {
                "MobileNumber": currentState.communicationModuleSearch.mobileNo == null || currentState.communicationModuleSearch.mobileNo == '' ? null : currentState.communicationModuleSearch.mobileNo,
                "CommStatusId": currentState.communicationModuleSearch.statusId == null || currentState.communicationModuleSearch.statusId == '' ? null : currentState.communicationModuleSearch.statusId,
                "ProductType": currentState.communicationModuleSearch.productType == null || currentState.communicationModuleSearch.productType == '' ? null : currentState.communicationModuleSearch.productType,
                "ServiceType": currentState.communicationModuleSearch.serviceType == null || currentState.communicationModuleSearch.serviceType == '' ? null : currentState.communicationModuleSearch.serviceType,
                "CommunicationNo": currentState.communicationModuleSearch.requestNo == null || currentState.communicationModuleSearch.requestNo == '' ? null : currentState.communicationModuleSearch.requestNo,
                "CreatedDate": currentState.communicationModuleSearch.createdDate == null || currentState.communicationModuleSearch.createdDate == '' ? null : currentState.communicationModuleSearch.createdDate,
                "ClosedDate": currentState.communicationModuleSearch.closedDate == null || currentState.communicationModuleSearch.closedDate == '' ? null : currentState.communicationModuleSearch.closedDate,
                "Page": page,
                "PageSize": 10,
                "SortString": ""

            };

            let pagedResult = await communicationModuleService.searchCommunicationMaster(inputPara);
            if (!pagedResult) {
                // dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            if (pagedResult) {
                dispatch(updateCommunictionSearchResult(pagedResult));
                //dispatch(setLegalEntrySearchResult(sr));
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export const updateCommunictionSearchResult = (pagedResult) => {
    return {
        type: types.UPDATE_COMMUNICATION_SEARCH_RESULT,
        pagedResult
    }
}
const getState = (state) => {
    return state.communicationModuleReducer;
};


export function getCommunicationModuleMasters() {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let sr = await communicationmoduleservice.getCommunicationModuleMasters();
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            console.log("masterss", sr)
            if (sr.result) {
                await dispatch(setCommunicationModuleMasters(sr.result));
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}

export function createNewUserLink(gernerateUserLink) {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let sr = await communicationmoduleservice.createNewUserLink(gernerateUserLink);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            if (sr.result) {
                // dispatch(setLawyerEntryParams({ name: "lawyerId", value: sr.result.lawyerId }));
                dispatch(appActions.showMessage("Link Created Successfully!", { buttons: ['Ok'] }));
                dispatch(setModalState({ name: "showCreateLinkDetails", value: false }));

                dispatch(onResetCreateLinkParams());

            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export const onResetCreateLinkParams = () => {
    return {
        type: types.RESET_CREATE_LINK_PARAMS,
    }
}

export function getCommunicationMasterById(commMasterId) {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let para = {
                commMasterId: commMasterId
            }
            let result = await communicationmoduleservice.getCommunicationMasterById(para);
            if (!result) {

                return false;
            }
            console.log("masterss", result)

            await dispatch(getCommunicationMasterByIdEnd({ result }));
            let currentState = getState(state());
            console.log("currentState", currentState.communicationMaster)

            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export const getCommunicationMasterByIdEnd = ({ result }) => {
    return {
        type: types.GET_CURRENT_MASTER_COMM_END,
        payload: { result }
    }
}
export const updateFileChange = ({ id, field, name, docIdEncrypted, type, date, intimationId, srlno }) => {

    return {
        type: types.UPDATE_COMMUNICATION_DOCUMENT_PARAMS,
        payload: { id, field, name, docIdEncrypted, type, date, intimationId, srlno }
    }
}
export const getCommunicationDocumentsListEnd = (result) => {
    return {
        type: types.GET_COMMUNICATION_DOCUMENTS_END,
        payload: result
    }
}
export const getCommunicationDocuments = (claimIntimationId, linkRefId) => {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let resp = await communicationmoduleservice.getCommunicationDocuments(claimIntimationId, linkRefId);
            if (resp.hasErrors) {
                dispatch(appActions.showValidationErrors(resp));
                return false;
            }
            else {
                await dispatch(getCommunicationDocumentsListEnd(resp?.result));
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    };
}
export const addNewCommunicationDocument = () => {
    return {
        type: types.ADD_NEW_COMMUNICATION_DOCUMENT
    }
}
export const updateCommunicationDocumentParams = ({ srlNo, name, value }) => {
    return {
        type: types.UPDATE_COMMUNICATION_DOCUMENT_DOCUMENT_PARAMS,
        payload: { srlNo, name, value }
    }
}
export const saveCommunicationDocuments = (documentList) => {
    return async function (dispatch, state) {
        try {
            let currentState = getState(state());
            dispatch(appActions.setLoading(true));
            let sr = await communicationmoduleservice.saveCommMasterDocuments(documentList);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            else {
                // await dispatch(getClaimInitimationDocuments(sr?.result));
                dispatch(getCommunicationDocuments(currentState?.communicationMaster.mcId, currentState?.communicationMaster.mcLinkId));
                dispatch(appActions.showMessage("Documents Successfully Saved!", { buttons: ['Ok'] }));
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}


export const resetCommunicationMasterParams = () => {
    return {
        type: types.RESET_COMMUNICATION_MODULE_MASTER_PARAMS
    }
}

export function saveCommunicationLog(lpoCommunication) {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let currentState = getState(state());
            let sr = await communicationmoduleservice.saveCommunicationLog(lpoCommunication);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            await dispatch(resetCommunicationTaskAssignment());
            await dispatch(getCommunicationsLogsbyMasterId(currentState?.communicationMaster.mcId, currentState?.communicationMaster.mcLinkId));
            await dispatch(getCommunicationMasterById(currentState?.communicationMaster.mcId));

            // dispatch(updateLPOCommunicationRecord(sr?.result));
            dispatch(appActions.showMessage("Communication Record Saved Successfully!", { buttons: ['Ok'] }));

            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export function getCommunicationsLogsbyMasterId(commMasterId, linkrefId) {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let sr = await communicationmoduleservice.getCommunicationsLogsbyMasterId(commMasterId, linkrefId);
            if (!sr) {
                // dispatch(appActions.showValidationErrors(sr));
                // return false;
            }
            console.log("srv1", sr)
            if (sr) {
                dispatch(getCommunicationsLogsEnd(sr));
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export const getCommunicationsLogsEnd = (payload) => {
    return {
        type: types.GET_COMMUNICATIONS_LOG_END,
        payload,
    }
}

export const onChangeUserEntryParams = ({ name, value }) => {
    return {
        type: types.ON_CHANGE_USER_OTP_PARAMS,
        payload: { name, value }
    }
}


export function createOtpForCommunication(commMasterId, linkrefId) {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let currentState = getState(state());
            let para = {
                MobileNumber: currentState?.userEntry.mobileNo,
                LinkRefId: currentState?.userEntry.linkId,
                OtpCode: currentState?.userEntry.otpCode,
                IsValidated: 'N',

            }
            let sr = await communicationmoduleservice.createOtpForCommunication(para);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            console.log("srv1", sr)
            if (sr) {
                dispatch(getCommunicationsLogsEnd(sr));
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export function validateOtpForCommunication() {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let currentState = getState(state());
            let para = {
                MobileNumber: currentState?.userEntry.mobileNo,
                LinkRefId: currentState?.userEntry.linkId,
                OtpCode: currentState?.userEntry.otpCode,
                IsValidated: 'N',

            }
            let sr = await communicationmoduleservice.validateOtpForCommunication(para);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }


            {
                let name = "isValidated";
                let value = "Y";
                dispatch(onChangeUserEntryParams({ name, value }));
            }
            {
                let name = "mcId";
                let value = sr.result.mcId;
                dispatch(onChangeUserEntryParams({ name, value }));
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export function saveCommunicationMaster() {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let currentState = getState(state());
            let para = {

                "McId": currentState?.userEntryDetails.mcId,
                "McName": currentState?.userEntryDetails.userName,
                "McMobileNumber": currentState?.userEntryDetails.userMobileNo,
                "McEmailId": currentState?.userEntryDetails.userEmail,
                "McLinkId": currentState?.userEntryDetails.mcLinkId,
                "McRemarks": currentState?.userEntryDetails.userRemarks,
                "VehCategory": currentState?.userEntryDetails.vehCategory,
                "IsVehicleFinanced": currentState?.userEntryDetails.isVehicleFinanced,
                "VehType": currentState?.userEntryDetails.vehType,
                "DocumentsList": currentState?.communicationDocuments.documentList,

            }
            let sr = await communicationmoduleservice.saveCommunicationMaster(para);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            dispatch(appActions.showTopMessage("Successfully Saved Information!", { autoClose: "n", messageType: "success" }));
            if (sr) {
                dispatch(getCommunicationsLogsEnd(sr));
            }
            dispatch(getCommunicationMasterForUserEntry(currentState?.userEntry.mcId, currentState?.userEntry.linkId));
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export function getCommunicationMasterForUserEntry(commMasterId, linkrefId) {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let para = {
                commMasterId: commMasterId,
                linkrefId: linkrefId,
            }
            let result = await communicationmoduleservice.getCommunicationMasterForUserEntry(para);
            if (!result) {

                return false;
            }
            console.log('result++', result)
            await dispatch(getCommunicationMasterForUserEntryEnd({ result }));
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export const getCommunicationMasterForUserEntryEnd = ({ result }) => {
    return {
        type: types.GET_CURRENT_MASTER_COMM_FOR_USER_ENTRY_END,
        payload: { result }
    }
}
export const onChangeUserEntryDetailsParams = ({ name, value }) => {
    return {
        type: types.ON_CHANGE_USER_DETAILS_PARAMS,
        payload: { name, value }
    }
}

export function submitCommunicationMaster(commMasterId, linkrefId) {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let para = {
                commMasterId: commMasterId,
                linkrefId: linkrefId,
            }
            let sr = await communicationmoduleservice.submitCommunicationMaster(para);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            dispatch(getCommunicationMasterForUserEntry(commMasterId, linkrefId));
            dispatch(appActions.showTopMessage("Successfully Submitted Information!", { autoClose: "n", messageType: "success" }));
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}

export function getCommunicationModuleMastersForUserEntry() {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let sr = await communicationmoduleservice.getCommunicationModuleMastersForUserEntry();
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            console.log("masterss", sr)
            if (sr.result) {
                await dispatch(setCommunicationModuleMasters(sr.result));
            }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}


export function onReOpenTask(commMasterId, linkrefId) {
    return async function (dispatch, state) {
        try {

            dispatch(appActions.setLoading(true));
            let currentState = getState(state());
            let para = {
                commMasterId: currentState?.communicationMaster.mcId,
                linkrefId: currentState?.communicationMaster.mcLinkId,
            }
            let sr = await communicationmoduleservice.onReOpenTask(para);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            dispatch(getCommunicationMasterById(currentState?.communicationMaster.mcId));
            dispatch(getCommunicationsLogsbyMasterId(currentState?.communicationMaster.mcId, currentState?.communicationMaster.mcLinkId));
            dispatch(appActions.showTopMessage("Successfully Re-Opened!", { autoClose: "n", messageType: "success" }));
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}


export const onUpdateDocumentsListFront = () => {
    return {
        type: types.UPDATE_DOCUMENTS_LIST_ON_FRONT,
    }
}


// Get Quote Online company website feature //

// export const getCommunicationMasterForGetQuoteOnlineEnd = ({ result }) => {
//     return {
//         type: types.GET_CURRENT_MASTER_COMM_FOR_GET_QUOTE_ONLINE_END,
//         payload: { result }
//     }
// }

export const onChangeGetQuoteOnlineDetailsParams = ({ name, value }) => {
    return {
        type: types.ON_CHANGE_GET_QUOTE_ONLINE_DETAILS_PARAMS,
        payload: { name, value }
    }
}

export function saveGetQuoteOnlineMaster() {
    return async function (dispatch, state) {
        try {
            dispatch(appActions.setLoading(true));
            let currentState = getState(state());
            let para = {
                "McId": 0,
                "McMobileNumber": currentState?.getQuoteOnlineDetails.userMobileNo,
                "McName": currentState?.getQuoteOnlineDetails.userName,
                "McEmailId": currentState?.getQuoteOnlineDetails.userEmail,
                "UserPrefLanguage": currentState?.getQuoteOnlineDetails.preferredLanguage,
                "McProductTypeId": currentState?.getQuoteOnlineDetails.userProductTypeId,
                "McServiceTypeId": currentState?.getQuoteOnlineDetails.userServiceTypeId,
                "McRemarks": currentState?.getQuoteOnlineDetails.userRemarks,
                "AgreeTerms": currentState?.getQuoteOnlineDetails.termsCheckbox,
                "UtmSourceName": currentState?.getQuoteOnlineDetails.utmSourceName,
                /*"VehCategory": currentState?.getQuoteOnlineDetails.vehCategory,
                "IsVehicleFinanced": currentState?.getQuoteOnlineDetails.isVehicleFinanced,
                "VehType": currentState?.getQuoteOnlineDetails.vehType,
                "DocumentsList": currentState?.getQuoteOnlineDocuments.documentList*/
            }
            let sr = await communicationmoduleservice.saveGetQuoteOnlineMaster(para);
            if (sr.hasErrors) {
                dispatch(appActions.showValidationErrors(sr));
                return false;
            }
            dispatch(appActions.showTopMessage("Successfully Saved Information!", { autoClose: "n", messageType: "success" }));
            // if (sr) {
                 dispatch(resetGetQuoteOnlineMasterParams());
            // }
            return true;
        } catch (e) {
            dispatch(appActions.handleError(e));
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }
}
export const resetGetQuoteOnlineMasterParams = () => {
    return {
        type: types.RESET_GET_QUOTE_ONLINE_MASTER_PARAMS
    }
}

export const onUpdateGetQuoteOnlineDocumentsListFront = () => {
    return {
        type: types.UPDATE_GET_QUOTE_ONLINE_DOCUMENTS_LIST_ON_FRONT,
    }
}

// Get Quote  Online Documents upload
export const updateGetQuoteOnlineFileChange = ({ id, field, name, docIdEncrypted, type, date, intimationId, srlno }) => {
  return {
    type: types.UPDATE_GET_QUOTE_ONLINE_DOCUMENT_PARAMS,
    payload: { id, field, name, docIdEncrypted, type, date, intimationId, srlno }
  }
}

export const updateGetQuoteOnlineDocumentParams = ({ srlNo, name, value }) => {
  return {
    type: types.UPDATE_GET_QUOTE_ONLINE_DOCUMENT_DOCUMENT_PARAMS,
    payload: { srlNo, name, value }
  }
}

export const addNewGetQuoteOnlineDocument = () => {
  return {
    type: types.ADD_NEW_GET_QUOTE_ONLINE_DOCUMENT
  }
}
export const toggleConfirmPopup = (data) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        type: types.TOGGLE_CONFRIM_POPUP,
        payload: {
          ...data,
          resolve: resolve,  // resolve the promise when the user clicks Yes/No
        }
      });
    });
  };
};
